import { AccessLevel } from "@/api/williams/users";
import { routes } from "../routes";

type LinkDefinition = {
  caption: string;
  route: string;
};

const LINKS_ADMINISTRATOR: LinkDefinition[] = [
  { caption: "My favorites", route: routes.dashboard.view("favorite") },
  { caption: "Search all", route: routes.miscellaneous.search },
  { caption: "Search or add projects", route: routes.project.list },
  { caption: "Search, add, or edit welders", route: routes.welder.list() },
  { caption: "Search welder certifications", route: routes.welder.list("certifications") },
  { caption: "Search standard test templates", route: routes.standardTests.list },
  { caption: "Request new standard test template", route: routes.standardTests.create },
  { caption: "Create project scope of work", route: routes.scopeOfWork.create },
  { caption: "Create test event", route: routes.testEvent.create },
  { caption: "Welder expirations", route: routes.welder.list("expirations") },
  { caption: "Add renewals", route: routes.welder.renewal },
  { caption: "Ownership transfers", route: routes.user.transferOwnership },
  { caption: "Incomplete items", route: routes.dashboard.view("incomplete") },
  { caption: "Search contractors & dashboard", route: routes.contractor.list },
  { caption: "Welding/NDE specialists", route: routes.miscellaneous.weldingSpecialists },
  { caption: "Reassign welding/NDE specialist", route: routes.user.transferSpecialist },
];

const LINKS_INSPECTOR: LinkDefinition[] = [
  { caption: "My favorites", route: routes.dashboard.view("favorite") },
  { caption: "Search all", route: routes.miscellaneous.search },
  { caption: "Search or add projects", route: routes.project.list },
  { caption: "Search, add, or edit welders", route: routes.welder.list() },
  { caption: "Search welder certifications", route: routes.welder.list("certifications") },
  { caption: "Search standard test templates", route: routes.standardTests.list },
  { caption: "Request new standard test template", route: routes.standardTests.create },
  { caption: "Create project scope of work", route: routes.scopeOfWork.create },
  { caption: "Create test event", route: routes.testEvent.create },
  { caption: "Welder expirations", route: routes.welder.list("expirations") },
  { caption: "Add renewals", route: routes.welder.renewal },
  { caption: "Transfer my ownership", route: routes.user.transferOwnership },
  { caption: "Incomplete items", route: routes.dashboard.view("incomplete") },
  { caption: "Welding/NDE specialists", route: routes.miscellaneous.weldingSpecialists },
];

const LINKS_SPECIALISTS: LinkDefinition[] = [
  { caption: "My favorites", route: routes.dashboard.view("favorite") },
  { caption: "Search all", route: routes.miscellaneous.search },
  { caption: "Search or add projects", route: routes.project.list },
  { caption: "Search, add, or edit welders", route: routes.welder.list() },
  { caption: "Search welder certifications", route: routes.welder.list("certifications") },
  { caption: "Search standard test templates", route: routes.standardTests.list },
  { caption: "Request new standard test template", route: routes.standardTests.create },
  { caption: "Create project scope of work", route: routes.scopeOfWork.create },
  { caption: "Create test event", route: routes.testEvent.create },
  { caption: "Welder expirations", route: routes.welder.list("expirations") },
  { caption: "Add renewals", route: routes.welder.renewal },
  { caption: "Ownership transfers", route: routes.user.transferOwnership },
  { caption: "Incomplete items", route: routes.dashboard.view("incomplete") },
  { caption: "Search contractors & dashboard", route: routes.contractor.list },
  { caption: "Welding/NDE specialists", route: routes.miscellaneous.weldingSpecialists },
];

const LINKS_WELDING_SME: LinkDefinition[] = [
  { caption: "My favorites", route: routes.dashboard.view("favorite") },
  { caption: "Search all", route: routes.miscellaneous.search },
  { caption: "Search or add projects", route: routes.project.list },
  { caption: "Search, add, or edit welders", route: routes.welder.list() },
  { caption: "Search welder certifications", route: routes.welder.list("certifications") },
  { caption: "Search standard test templates", route: routes.standardTests.list },
  { caption: "Request new standard test template", route: routes.standardTests.create },
  { caption: "Create project scope of work", route: routes.scopeOfWork.create },
  { caption: "Create test event", route: routes.testEvent.create },
  { caption: "Welder expirations", route: routes.welder.list("expirations") },
  { caption: "Add renewals", route: routes.welder.renewal },
  { caption: "Ownership transfers", route: routes.user.transferOwnership },
  { caption: "Incomplete items", route: routes.dashboard.view("incomplete") },
  { caption: "Search contractors & dashboard", route: routes.contractor.list },
  { caption: "Welding/NDE specialists", route: routes.miscellaneous.weldingSpecialists },
  { caption: "Reassign welding/NDE specialist", route: routes.user.transferSpecialist },
];

const LINKS_GENERAL: LinkDefinition[] = [
  { caption: "My favorites", route: routes.dashboard.view("favorite") },
  { caption: "Search all", route: routes.miscellaneous.search },
  { caption: "Search projects", route: routes.project.list },
  { caption: "Search welders", route: routes.welder.list() },
  { caption: "Search welder certifications", route: routes.welder.list("certifications") },
  { caption: "Welder expirations", route: routes.welder.list("expirations") },
  { caption: "Welding/NDE specialists", route: routes.miscellaneous.weldingSpecialists },
];

export function getLinks(role?: AccessLevel) {
  switch (role) {
    case AccessLevel.Administrator:
      return LINKS_ADMINISTRATOR;
    case AccessLevel.WeldingInspector:
      return LINKS_INSPECTOR;
    case AccessLevel.WeldingSpecialist:
      return LINKS_SPECIALISTS;
    case AccessLevel.AIWeldingSME:
      return LINKS_WELDING_SME;
    default:
      return LINKS_GENERAL;
  }
}
